<template>
  <div>
    <div style="text-align: left;">
      <div class="row" style="height: 60px"></div>
      <div class="row titleRow">
        <div class="col">
          <h1>{{$t('starterPack.title')}}</h1>
        </div>
      </div>
      <div class="row ">
        <div class="col">
          <span v-html="$store.state.config.starterPack"></span>
        </div>
      </div><br/>

      <form accept-charset="utf-8" class="needs-validation" novalidate>
        <div v-if="activePackage">
          <div class="row titleRow">
            <div class="col">
              <h2>{{$store.state.config.prices.employedPackages.name}}</h2>
            </div>
          </div>
            <div class="form-row">
              <div class="form-group col-md-5">
                <div class="input-group">
                  <input type="number" min="0" v-model="pricePackage" class="form-control" required>
                  <div class="input-group-prepend">
                    <span class="input-group-text form-control" v-html="optionPackage"></span>
                  </div>
                  <div class="invalid-feedback">
                    {{$t('starterPack.formValidation.pricePackage')}}
                  </div>
                </div>
              </div>
          </div>
        </div>

        <div v-if="activeInsurance">
          <div class="row titleRow">
            <div class="col">
              <h2>{{$store.state.config.prices.insurance.name}}</h2>
            </div>
          </div>
          <!--<div class="row ">-->
            <!--<div class="col">-->
              <!--TODO ? description assurance-->
            <!--</div>-->
          <!--</div>-->
          <div class="form-row">
            <div class="form-group col-md-5">
              <div class="input-group">
                <input type="number" min="0" v-model="priceInsurance" class="form-control" :required="choiceInsurance">
                <div class="input-group-prepend">
                  <span class="input-group-text form-control" v-html="optionInsurance"></span>
                </div>
                <div class="invalid-feedback">
                  {{$t('starterPack.formValidation.priceInsurance')}}
                </div>
              </div>
            </div>
            <div class="form-group col-md-1"></div>
            <div class="form-group col-md-3 verticalCenter">
              <p style="display: contents;text-align: left"><em>{{$t('starterPack.insurance')}}</em></p>
            </div>
            <div class="form-group col-md-1 verticalCenter">
              <label class="switch">
                <input v-model="choiceInsurance" type="checkbox">
                <span class="slider round"></span>
              </label>
            </div>
          </div>
          <div class="form-row">
          </div>
        </div>

        <div v-if="activeSmoothIncrease">
          <div class="row titleRow">
            <div class="col">
              <h2>{{$t('starterPack.subtitleSmoothIncrease')}}</h2>
            </div>
          </div>
          <div class="row ">
            <div class="col">
              {{$t('starterPack.descriptionSmoothIncrease')}}
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-5">
              <div class="input-group">
                <input type="number" min="0" v-model="priceSmoothIncrease" class="form-control" required>
                <div class="input-group-prepend">
                  <span class="input-group-text form-control" v-html="optionSmoothIncrease"></span>
                </div>
                <div class="invalid-feedback">
                  {{$t('starterPack.formValidation.priceSmoothIncrease')}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col overFooter">
          <button type="submit" :class="'btn btn-primary alignRight ' + (isAuthorized() ? 'bg-color' : '')" @click="saveData()">{{$t('general.next')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'starter-pack',
  data () {
    return {
    };
  },
  updated: function () {
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {layout: 'StarterPack', isAuthorized: this.isAuthorized(), data: {}});
  },
  created: function () {
    // On pré-rempli le resultJson avec les données de la config
    let starterPack = {
      pricePackage: (this.$store.state.config.prices.employedPackages.active ? this.$store.state.config.prices.employedPackages.price : null),
      priceSmoothIncrease: (this.$store.state.config.prices.smoothIncrease.active ? this.$store.state.config.prices.smoothIncrease.price : null),
      priceInsurance: (this.$store.state.config.prices.insurance.active ? this.$store.state.config.prices.insurance.price : null),
      choiceInsurance: false
    };
    this.$store.commit('form/FORM_SAVEDATA', {starterPack: starterPack});
  },
  mounted: function () {
    // On vérifie l'autorisation de l'étape suivante au montage, les informations étant noralement préremplies
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {layout: 'StarterPack', isAuthorized: this.isAuthorized(), data: {}});
  },
  methods: {
    saveData: function () {
      if (this.isAuthorized()) {
        this.$store.dispatch('form/FORM_NEXTLAYOUT', {});
      }
    },
    getPeriodTranslation: function (period, duration) {
      let translatedPeriod = '';
      switch (period) {
        case 'week':
          translatedPeriod = this.$tc('config.commitments.week', (duration > 1) ? 2 : 1);
          break;
        case 'month':
          translatedPeriod = this.$t('config.commitments.month', (duration > 1) ? 2 : 1);
          break;
        case 'year':
          translatedPeriod = this.$tc('config.commitments.year', (duration > 1) ? 2 : 1);
          break;
      }
      return translatedPeriod;
    },
    isAuthorized () {
      return !((this.activePackage && isNaN(parseInt(this.$store.state.form.resultJson.starterPack.pricePackage))) || (this.activeSmoothIncrease && isNaN(parseInt(this.$store.state.form.resultJson.starterPack.priceSmoothIncrease))) || (this.activeInsurance && isNaN(parseInt(this.$store.state.form.resultJson.starterPack.priceInsurance))));
    }
  },
  computed: {
    dataTosave: function () {
      return {
        starterPack: {
          pricePackage: (this.$store.state.config.prices.employedPackages.active ? this.$store.state.form.resultJson.starterPack.pricePackage : null),
          priceSmoothIncrease: (this.$store.state.config.prices.smoothIncrease.active ? this.$store.state.form.resultJson.starterPack.priceSmoothIncrease : null),
          priceInsurance: (this.$store.state.config.prices.insurance.active ? this.$store.state.form.resultJson.starterPack.priceInsurance : null),
          choiceInsurance: this.$store.state.form.resultJson.starterPack.choiceInsurance
        }
      };
    },
    optionPackage: function () {
      return this.$store.state.config.mainconfig.currency + ' / ' + this.$store.state.config.prices.employedPackages.duration + ' ' + this.getPeriodTranslation(this.$store.state.config.prices.employedPackages.commitment, this.$store.state.config.prices.employedPackages.duration).toLowerCase();
    },
    optionSmoothIncrease: function () {
      return this.$store.state.config.mainconfig.currency + ' / ' + this.$store.state.config.prices.smoothIncrease.duration + ' ' + this.getPeriodTranslation(this.$store.state.config.prices.smoothIncrease.commitment, this.$store.state.config.prices.smoothIncrease.duration).toLowerCase();
    },
    optionInsurance: function () {
      return this.$store.state.config.mainconfig.currency;
    },

    activePackage: function () {
      return this.$store.state.config.prices.employedPackages.active;
    },
    activeSmoothIncrease: function () {
      return this.$store.state.config.prices.smoothIncrease.active;
    },
    activeInsurance: function () {
      return this.$store.state.config.prices.insurance.active;
    },
    choiceInsurance: {
      get: function () {
        return this.$store.state.form.resultJson.starterPack.choiceInsurance;
      },
      set: function (value) {
        let starterPack = {
          pricePackage: (this.$store.state.config.prices.employedPackages.active ? this.$store.state.form.resultJson.starterPack.pricePackage : null),
          priceSmoothIncrease: (this.$store.state.config.prices.smoothIncrease.active ? this.$store.state.form.resultJson.starterPack.priceSmoothIncrease : null),
          priceInsurance: (this.$store.state.config.prices.insurance.active ? this.$store.state.form.resultJson.starterPack.priceInsurance : null),
          choiceInsurance: value
        };
        this.$store.commit('form/FORM_SAVEDATA', {starterPack: starterPack});
      }
    },
    pricePackage: {
      get: function () {
        return this.$store.state.form.resultJson.starterPack.pricePackage;
      },
      set: function (value) {
        let starterPack = {
          pricePackage: value,
          priceSmoothIncrease: (this.$store.state.config.prices.smoothIncrease.active ? this.$store.state.form.resultJson.starterPack.priceSmoothIncrease : null),
          priceInsurance: (this.$store.state.config.prices.insurance.active ? this.$store.state.form.resultJson.starterPack.priceInsurance : null),
          choiceInsurance: this.$store.state.form.resultJson.starterPack.choiceInsurance
        };
        this.$store.commit('form/FORM_SAVEDATA', {starterPack: starterPack});
      }},
    priceSmoothIncrease: {
      get: function () {
        return this.$store.state.form.resultJson.starterPack.priceSmoothIncrease;
      },
      set: function (value) {
        let starterPack = {
          pricePackage: (this.$store.state.config.prices.employedPackages.active ? this.$store.state.form.resultJson.starterPack.pricePackage : null),
          priceSmoothIncrease: value,
          priceInsurance: (this.$store.state.config.prices.insurance.active ? this.$store.state.form.resultJson.starterPack.priceInsurance : null),
          choiceInsurance: this.$store.state.form.resultJson.starterPack.choiceInsurance
        };
        this.$store.commit('form/FORM_SAVEDATA', {starterPack: starterPack});
      }},
    priceInsurance: {
      get: function () {
        return this.$store.state.form.resultJson.starterPack.priceInsurance;
      },
      set: function (value) {
        let starterPack = {
          pricePackage: (this.$store.state.config.prices.employedPackages.active ? this.$store.state.form.resultJson.starterPack.pricePackage : null),
          priceSmoothIncrease: (this.$store.state.config.prices.smoothIncrease.active ? this.$store.state.form.resultJson.starterPack.priceSmoothIncrease : null),
          priceInsurance: value,
          choiceInsurance: this.$store.state.form.resultJson.starterPack.choiceInsurance
        };
        this.$store.commit('form/FORM_SAVEDATA', {starterPack: starterPack});
      }}
  }
};
</script>

<style scoped>
  ol li {
    padding-bottom: 30px;
  }
  li {
    max-width: 1000px;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/StarterPack.vue